import { Axios } from '@src/app/context/Api/includes/Axios/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isUndefined } from 'lodash';

/**
 * GetUserRoles
 *
 * Retrieves a list of user roles from the remote API via an authenticated request.
 *
 * @returns {Promise<{}>}
 * @constructor
 */
export const GetUserRoles = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      method: 'GET',
      url: '/user/roles/get',
    };

    if (!isUndefined(payload)) {
      requestArgs.params = { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePayload };
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/User/api/requests/queries/GetUserRoles.js -> GetUserRoles()', false, error);

    throw error;
  }
};
